import { Button, ButtonGroup, IconCheckCircle, Modal } from '@veneer/core';
import './index.css';

interface ModalCheckoutContinueProps {
  showOrderConfirmationModal: boolean;
  onOrderConfirmedModalOkayTapped: () => void;
  category: string;
  onOrderConfirmedModalCloseTapped: () => void;
}

const ModalCheckoutContinue = (props: ModalCheckoutContinueProps) => {
  const categoryDescription: {
    [index: string]: JSX.Element;
  } = {
    photobook: (
      <>
        <p>Thank you for creating your personalized HP Photobook.</p>
        <p>Tell us what you think!</p>
      </>
    ),
    canvas: (
      <>
        <p>Thank you for creating your personalized HP Canvas.</p>
        <p>Tell us what you think!</p>
      </>
    ),
  };

  return (
    <Modal
      id="continue-modal"
      className="continueModal"
      closeButton
      onClose={props.onOrderConfirmedModalCloseTapped}
      show={props.showOrderConfirmationModal}
      title="Order confirmed!"
      align="center"
      footer={
        <ButtonGroup>
          <Button className="confirmButton" onClick={props.onOrderConfirmedModalOkayTapped}>
            Take a short survey
          </Button>
        </ButtonGroup>
      }
    >
      <IconCheckCircle size={72} color="colorHpBlue6" />
      <div className="description">{categoryDescription[props.category]}</div>
    </Modal>
  );
};

export default ModalCheckoutContinue;
